<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>
            <v-flex xs1/>
            <v-flex xs11>
              <v-row
                class="mb-6"
                no-gutters
              >
                <v-col md="4" class="pa-2"
                >
                  <v-card
                    height="100%"
                    class="pa-5"
                    outlined
                    tile
                  >
                    <v-layout row wrap>                                         
                      <v-flex xs12>
                        <Assets/>
                      </v-flex>                                            
                    </v-layout>                                        
                  </v-card>
                </v-col>

                <v-col md="8" class="pa-2"
                >
                  <v-card
                    height="100%"
                    class="pa-5"
                    outlined
                    tile
                  >
                    <v-layout row wrap>   
                      <v-flex xs1/>                   
                      <v-flex xs3>
                        <v-combobox
                          :items="periodList"
                          label="Select Start Period"
                          item-text="text"
                          v-model="selectedSplineStartDate"
                          single-line
                          return-object
                          v-on:change="splineStartPeriodChanged"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs1/>    
                      <v-flex xs3>
                        <v-combobox
                            :items="periodList"
                            label="Select End Period"
                            item-text="text"
                            v-model="selectedSplineEndDate"
                            single-line
                            return-object
                            v-on:change="splineEndPeriodChanged"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs4/>
                      <v-flex xs12>
                        <chartSpline 
                        :chart-title="this.incomeExpenseTitle" 
                        :x-axis-categories="this.incomeExpenseCategories" 
                        :y-axis-title="this.incomeExpenseYAxisTitle"
                        :series="this.incomeExpenseSeries"/>
                      </v-flex>
                    </v-layout>                                       
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                class="mb-6"
                no-gutters
              >
                <v-col md="6" class="pa-2"
                >
                  <v-card
                    outlined
                    tile
                  >
                    <v-layout row wrap>   
                      <v-flex xs1/>                   
                      <v-flex xs3>
                        <v-combobox
                          :items="periodList"
                          label="Select Start Period"
                          item-text="text"
                          v-model="selectedStartDate"
                          single-line
                          return-object
                          v-on:change="startPeriodChanged"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs1/>    
                      <v-flex xs3>
                        <v-combobox
                            :items="periodList"
                            label="Select End Period"
                            item-text="text"
                            v-model="selectedEndDate"
                            single-line
                            return-object
                            v-on:change="endPeriodChanged"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs4/>
                      <v-flex xs12>
                        <chartPie 
                        :chart-title="this.expensePieTitle" 
                        :series="this.expensePieSeries"/>
                      </v-flex>
                    </v-layout>  
                  </v-card>
                </v-col>
                <v-col md="6" class="pa-2"
                >
                  <v-card
                    outlined
                    tile
                  >
                    <v-layout row wrap>   
                      <v-flex xs1/>                   
                      <v-flex xs3>
                        <v-combobox
                          :items="periodList"
                          label="Select Start Period"
                          item-text="text"
                          v-model="assumptionSelectedStartDate"
                          single-line
                          return-object
                          v-on:change="assumptionStartPeriodChanged"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs1/>    
                      <v-flex xs3>
                        <v-combobox
                            :items="periodList"
                            label="Select End Period"
                            item-text="text"
                            v-model="assumptionSelectedEndDate"
                            single-line
                            return-object
                            v-on:change="assumptionEndPeriodChanged"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs4/>
                      <v-flex xs12>
                        <chartPie 
                        :chart-title="this.assumptionsPieTitle" 
                        :series="this.assumptionsPieSeries"/>
                      </v-flex>
                    </v-layout>  
                  </v-card>
                </v-col>
              </v-row>  
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import LeftMenu from '../components/LeftMenu';
import Assets from '../components/Assets';
import ChartSpline from '../components/charts/ChartSpline.vue';
import ChartPie from '../components/charts/ChartPie.vue';

const EXPENSES_API_URL = 'expenses';
const ASSUMPTIONS_API_URL = 'budgetAssumptions';
const INCOMES_API_URL = 'incomes';
const PERIODS_API_URL = 'definitions/periods';
const FUTURE_PERIODS_API_URL = 'definitions/periods/withFutures';

export default {
  components:{
    LeftMenu,
    Assets,
    chartSpline: ChartSpline,
    chartPie: ChartPie,

  },
  name: 'home',  
  data() {
    return {
      expensePieTitle: "Expenses by categories",
      expensePieSeries:[{
          name: 'Expenses',
          colorByPoint: true,
          data: [{}]
        }],
      assumptionsPieTitle: "Assumptions by categories",
      assumptionsPieSeries:[{
          name: 'Assumptions',
          colorByPoint: true,
          data: [{}]
        }],

      incomeExpenseTitle: "Income - Expense by months",
      incomeExpenseYAxisTitle: "TRY",
      incomeExpenseCategories: [],
      incomeExpenseSeries: [
        {
          name: 'Incomes',
          data: []
        },
        {
          name: 'Expenses',
          data: []
        }
      ],
      periodList: [],
      futurePeriodList: [],
      selectedEndDate: {},
      selectedStartDate: {},
      assumptionSelectedEndDate: {},
      assumptionSelectedStartDate: {},
      selectedSplineEndDate: {},
      selectedSplineStartDate: {}
    }
  },
  created() {        
    this.getPeriods();    
  },
  methods: {    
    async getPeriods(){
      await this.getPerformancePeriodList();
      await this.getFuturePerformancePeriodList();
    },
    async fillPieChart(){
      let periodCount = 0;
      if(this.periodList)
        periodCount = this.periodList.length;

      if(periodCount>2){
        this.selectedStartDate = this.periodList[2];
        this.selectedEndDate = this.periodList[0];
        await this.getExpenseTotalsByCategories(this.selectedStartDate.id,this.selectedEndDate.id);       
      }      
    },
    async fillAssumptionPieChart(){
      let periodCount = 0;
      if(this.futurePeriodList)
        periodCount = this.futurePeriodList.length;

      if(periodCount>2){
        this.assumptionSelectedStartDate = this.futurePeriodList[0];
        this.assumptionSelectedEndDate = this.futurePeriodList[0];
        await this.getAssumptionTotalsByCategories(this.assumptionSelectedStartDate.id,this.assumptionSelectedEndDate.id);       
      }      
    },
    async fillIncomeExpenseChart(){
      if(this.periodList){
        let periodCount = 0;
        this.selectedSplineEndDate = this.periodList[0];
        if(periodCount>12){
          this.selectedSplineStartDate = this.periodList[11];
        }else{
          this.selectedSplineStartDate = this.periodList[this.periodList.length-1];
        }
        await this.getIncomeExpenseTotalsByPeriods(this.selectedSplineStartDate.id,this.selectedSplineEndDate.id);  
      }
    },
    async getIncomeExpenseTotalsByPeriods(startPeriodId,endPeriodId){       
        this.$axios.get(this.$apiurl + EXPENSES_API_URL+'/totals/periods/'+startPeriodId+'/'+endPeriodId)
            .then(response => {                        
                const expenseMap = new Map(Object.entries(response.data.resultMap));                
                this.incomeExpenseSeries[1].data = [];
                this.incomeExpenseCategories.length = 0;
                expenseMap.forEach((value, key) => {
                  this.incomeExpenseSeries[1].data.push(value);
                  this.incomeExpenseCategories.push(key);
                });      
                this.getIncomeTotalsByPeriods(startPeriodId,endPeriodId);
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    async getIncomeTotalsByPeriods(startPeriodId,endPeriodId){     
        this.$axios.get(this.$apiurl + INCOMES_API_URL+'/totals/periods/'+startPeriodId+'/'+endPeriodId)
            .then(response => {             
                const incomeMap = new Map(Object.entries(response.data.resultMap));                
                this.incomeExpenseSeries[0].data = [];
                incomeMap.forEach((value, key) => {
                  this.incomeExpenseSeries[0].data.push(value);
                });      
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    async getExpenseTotalsByCategories(startPeriodId,endPeriodId){         
        this.$axios.get(this.$apiurl + EXPENSES_API_URL+'/categories/periods/'+startPeriodId+'/'+endPeriodId)
            .then(response => {                        
                const expenseMap = new Map(Object.entries(response.data.resultMap));                
                this.expensePieSeries[0].data = [];
                expenseMap.forEach((value, key) => {
                  this.expensePieSeries[0].data.push({name:key , y: value})
                });      
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    async getAssumptionTotalsByCategories(startPeriodId,endPeriodId){         
        this.$axios.get(this.$apiurl + ASSUMPTIONS_API_URL+'/categories/periods/'+startPeriodId+'/'+endPeriodId)
            .then(response => {                        
                const assumptionMap = new Map(Object.entries(response.data.resultMap));                
                this.assumptionsPieSeries[0].data = [];
                assumptionMap.forEach((value, key) => {
                  this.assumptionsPieSeries[0].data.push({name:key , y: value})
                });      
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    async getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl + PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data;
                this.fillIncomeExpenseChart();
                this.fillPieChart(); 
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    async getFuturePerformancePeriodList(){     
        this.$axios.get(this.$apiurl + FUTURE_PERIODS_API_URL)
            .then(response => {
                this.futurePeriodList = response.data;
                this.fillAssumptionPieChart();
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    startPeriodChanged(item){    
      this.selectedStartDate = item;  
      if(this.selectedEndDate){
        this.getExpenseTotalsByCategories(this.selectedStartDate.id,this.selectedEndDate.id);
      }      
    },
    endPeriodChanged(item){
      this.assumptionSelectedEndDate = item;
      if(this.assumptionSelectedStartDate){
        this.getExpenseTotalsByCategories(this.assumptionSelectedStartDate.id,this.assumptionSelectedEndDate.id);
      }  
    },
    assumptionStartPeriodChanged(item){    
      this.assumptionSelectedStartDate = item;  
      if(this.assumptionSelectedEndDate){
        this.getAssumptionTotalsByCategories(this.assumptionSelectedStartDate.id,this.assumptionSelectedEndDate.id);
      }      
    },
    assumptionEndPeriodChanged(item){
      this.selectedEndDate = item;
      if(this.selectedStartDate){
        this.getAssumptionTotalsByCategories(this.selectedStartDate.id,this.selectedEndDate.id);
      }  
    },
    splineStartPeriodChanged(item){    
      this.selectedSplineStartDate = item;  
      if(this.selectedSplineEndDate){
        this.getIncomeExpenseTotalsByPeriods(this.selectedSplineStartDate.id,this.selectedSplineEndDate.id);
      }      
    },
    splineEndPeriodChanged(item){
      this.selectedSplineEndDate = item;
      if(this.selectedSplineStartDate){
        this.getIncomeExpenseTotalsByPeriods(this.selectedSplineStartDate.id,this.selectedSplineEndDate.id);
      }  
    }
  }       

}
</script>
